// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import { Input } from "reactstrap";

import { View, Text, Checkbox } from "@components";
import type { AlertEmailContent } from "@modules/service/reducer/alerts/types";

type OwnProps = $Exact<{
  data: ?AlertEmailContent,
  schema: Object,
  onChange?: (data: AlertEmailContent) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AlertContentForm extends React.Component<Props> {
  get booleanFields() {
    const props: Object = (this.props.schema || {}).properties;
    if (!props) {
      return [];
    }

    // $FlowIgnore I need to use Object and not mixed https://github.com/facebook/flow/blob/v0.92.1/lib/core.js#L48
    return Object.entries(props)
      .filter(([k, v]: [string, Object]) => v.type === "boolean")
      .map(([k, v]: [string, Object]) => k);
  }

  handleTextChange = (e: SyntheticEvent<HTMLInputElement>) => {
    if (!this.props.onChange) return false;
    const next = {
      ...this.props.data,
      [e.currentTarget.name]: e.currentTarget.value || null,
    };

    this.props.onChange(next);
  };

  handleCheckboxChange = (id: string) => () => {
    if (!this.props.onChange) return false;
    const next = {
      ...this.props.data,
      [id]: !this.props.data[id],
    };

    this.props.onChange(next);
  };

  render() {
    return (
      <View direction="row" gap={4}>
        <View gap={3} className="gs-container" flex={1}>
          <View direction="row" gap="1">
            <Text type="h6" text={this.props.t("INSTRUCTION")} />
            <Text type="h6" className="text-warning" text="*" />
          </View>
          <View>
            {!!this.props.onChange ? (
              <Input
                type="textarea"
                row={3}
                name="instructionText"
                defaultValue={(this.props.data || {}).instructionText}
                onBlur={this.handleTextChange}
              />
            ) : (
              <Text text={(this.props.data || {}).instructionText} />
            )}
          </View>
        </View>
        <View gap={3} className="gs-container" flex={1}>
          <Text type="h6" text={this.props.t("FIELDS")} />
          <View display="grid" gap={1} gridTemplateColumns={3}>
            {this.booleanFields.map(k => (
              <Checkbox
                key={k}
                id={k}
                label={(this.props.schema || {}).properties[k].title}
                checked={(this.props.data || {})[k]}
                onChange={this.handleCheckboxChange(k)}
                disabled={!!!this.props.onChange}
              />
            ))}
          </View>
        </View>
      </View>
    );
  }
}

export default localize()(AlertContentForm);
